export enum PreshippingId {
  BASIC = "basic",
  PASSCULTURE = "passculture",
  THOMSON = "thomson",
  PARTNER = "partner",
  POST = "post",
  AIS = "ais",
  DREI = "drei",
}
